import React from 'react';
import { Check, AlertTriangle } from 'lucide-react';
import { avatarColor, employeeInitials } from '../helpers';
import { SUCCESS_TEXT, WARN_DOT } from '../styles';
import type { Employee } from '../types';

interface Props {
  emp: Employee;
}

export default function Avatar({ emp }: Props) {
  const initials = employeeInitials(emp);
  const color = avatarColor(emp);
  const ready = Boolean(emp._ready);

  return (
    <div style={{ position: 'relative', width: 42, height: 42, flexShrink: 0 }}>
      <div style={{
        width: 42, height: 42, borderRadius: '50%',
        background: color, color: 'white',
        display: 'grid', placeItems: 'center',
        fontWeight: 600, fontSize: 14,
      }}>
        {initials}
      </div>
      <div style={{
        position: 'absolute', right: -2, bottom: -2,
        width: 18, height: 18, borderRadius: '50%',
        background: ready ? SUCCESS_TEXT : WARN_DOT,
        border: '2px solid white',
        display: 'grid', placeItems: 'center',
      }}>
        {ready
          ? <Check size={10} style={{ color: 'white' }} />
          : <AlertTriangle size={10} style={{ color: 'white' }} />}
      </div>
    </div>
  );
}